import { render, staticRenderFns } from "./AiIntentGenerateModal.vue?vue&type=template&id=b064d1ea&scoped=true"
import script from "./AiIntentGenerateModal.vue?vue&type=script&lang=js"
export * from "./AiIntentGenerateModal.vue?vue&type=script&lang=js"
import style0 from "./AiIntentGenerateModal.vue?vue&type=style&index=0&id=b064d1ea&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b064d1ea",
  null
  
)

export default component.exports